import features from '@/assets/stripo_templates_categories/features'
import industries from '@/assets/stripo_templates_categories/industries'
import seasons from '@/assets/stripo_templates_categories/seasons'
import types from '@/assets/stripo_templates_categories/types'
import i18n from '@/languages/index.js'

const emailsTemplatesCategoriesModule = {
  state: {
    features: [],
    industries: [],
    seasons: [],
    types: []
  },
  mutations: {
    setFeatures: (state, features) => (state.features = features),
    setIndustries: (state, industries) => (state.industries = industries),
    setSeasons: (state, seasons) => (state.seasons = seasons),
    setTypes: (state, types) => (state.types = types)
  },
  actions: {
    initEmailTemplatesCategories ({dispatch}) {
      dispatch('getFeatures')
      dispatch('getIndustries')
      dispatch('getSeasons')
      dispatch('getTypes')
    },

    getFeatures ({commit}) {
      const result = []
      for (let key in features) {
        result.push(features[key])
      }
      commit('setFeatures', result)
    },
    getIndustries ({commit}) {
      const result = []
      for (let key in industries) {
        result.push(industries[key])
      }
      commit('setIndustries', result)
    },
    getSeasons ({commit}) {
      const result = []
      for (let key in seasons) {
        result.push(seasons[key])
      }
      commit('setSeasons', result)
    },
    getTypes ({commit}) {
      const result = []
      for (let key in types) {
        result.push(types[key])
      }
      commit('setTypes', result)
    }
  },
  getters: {
    getAllTemplatesCategories: (state) => {
      const result = {}
      for (let key in state) {
        result[key] = {...state[key]}
        for (let k in result[key]) {
          result[key][k] = {...result[key][k], category: key}

          if (result[key][k].name === '') {
            result[key][k].name = 'no_name'
          }

          let name = result[key][k].name
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '_')
            .replace(/-/g, '_')
            .replace(/&/g, 'and')
            .replace(/'/g, '')

          result[key][k].name = i18n.t(`stripo_template_categories.${key}.${name}`, i18n.locale)
        }
      }

      return result
    }
  }
}

export default emailsTemplatesCategoriesModule



// WEBPACK FOOTER //
// ./src/store/modules/email_templates_categories.js